import { testimonials } from '@/mocks/data';

const starIcons = (rating: number) => {
  return Array.from({ length: 5 }, (_, i) => (
    <i
      key={i}
      className={`text-sm ${i < rating ? 'ri-fire-fill text-accent-500' : 'ri-fire-line text-foreground-300'}`}
    ></i>
  ));
};

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold text-foreground-600 tracking-widest uppercase">
              吃瓜群众热评
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
            千万吃瓜人的选择
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            来看看大家都怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={t.id}
              className={`p-5 md:p-6 rounded-2xl bg-background-50 transition-all duration-300 ${
                idx === testimonials.length - 1 ? 'opacity-60 hover:opacity-100' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {starIcons(t.rating)}
              </div>
              <h4 className="text-base font-bold text-foreground-950 mb-2">
                {t.content.slice(0, 20)}...
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3">
                {t.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}